<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_customer') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.customer') }} <strong>{{ customer.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-customer-new *ngIf="newMode()"></app-customer-new>
            <app-customer-basedata *ngIf="editMode()" [customer]="customer"></app-customer-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
